// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2XWOU","location":"Header_location__3fyGt"};